import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { FormattedMessage } from 'react-intl';

import { useHistory } from 'react-router';
import { cleanUser } from '@/modules/User';
import { Flex } from '@/components/UIKit/Grid';

const Logout = ({ onLogout }) => {
  useEffect(() => {
    onLogout();
  }, []);

  const [time, setTime] = useState(3);
  const history = useHistory();

  useEffect(() => {
    const timeout = setTimeout(
      () => (time > 0 ? setTime(time - 1) : history.push('/')),
      1000
    );

    return () => clearTimeout(timeout);
  }, [time]);

  return (
    <Flex justifyContent="space-between">
      <FormattedMessage id="logout.success_message" defaultMessage="" />
      <span>Redirect in {time}...</span>
    </Flex>
  );
};

Logout.propTypes = {
  onLogout: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  onLogout() {
    cookie.remove('Authorization', { path: '/' });
    dispatch(cleanUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
